import { getMeta } from '@helpcenter/meta';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';

import CsmSupportWidgetConfigQuery, {
	type supportWidgetConfigProviderQuery,
} from '../support-widget-config-provider/__generated__/supportWidgetConfigProviderQuery.graphql';

export const csmSupportWidgetConfigQueryResource =
	createRelayResource<supportWidgetConfigProviderQuery>({
		type: 'CSM_SUPPORT_WIDGET_CONFIG_QUERY',
		getQuery: () => ({
			parameters: CsmSupportWidgetConfigQuery,
			variables: {
				helpCenterAri: getMeta('help-center-ari') ?? '',
				cloudId: getMeta('tenant-id') ?? '',
			},
			options: {
				fetchPolicy: 'store-or-network',
			},
		}),
	});
